import { render, staticRenderFns } from "./envio-seguimiento.vue?vue&type=template&id=1533d9f2&scoped=true&"
import script from "./envio-seguimiento.vue?vue&type=script&lang=ts&"
export * from "./envio-seguimiento.vue?vue&type=script&lang=ts&"
import style0 from "./envio-seguimiento.vue?vue&type=style&index=0&id=1533d9f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1533d9f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCol,VIcon,VRow,VSpacer})
